import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext'; // Verifique se este import está correto

const CidadeContext = createContext();

export const useCidades = () => useContext(CidadeContext); // Certifique-se de exportar esta função

export const CidadeProvider = ({ children }) => {
    const [cidades, setCidades] = useState([]);
    const { showAlert } = useAlert();

    const fetchCidades = useCallback(async () => {
        try {
            const result = await fetchData('/Cidade');
            setCidades(result);
        } catch (error) {
            console.error('Erro ao buscar cidades:', error);
            showAlert(`Erro ao carregar cidades! ${error?.message || error}`, 'danger');
        }
    }, [showAlert]); // Dependência de fetchCidades

    useEffect(() => {
        fetchCidades();
    }, [fetchCidades]); // fetchCidades como dependência

    

    return (
        <CidadeContext.Provider value={{ cidades }}>
            {children}
        </CidadeContext.Provider>
    );
};
